import React from 'react';
import { Typography, Ul } from '@vp/swan';

import { useUserFeatureContext } from '@vp/core-ui-components';
import { DebugFeatureControls } from './DebugFeatureControls';
import { DebugNewFeatureEntry } from './DebugNewFeatureEntry';

export const DebugFeaturePanel = () => {
  const { overrideFeatureSettings, activeFeatures } = useUserFeatureContext();

  if (!activeFeatures || activeFeatures.length < 1) {
    return (
      <div>
        <Typography> It appears you have no active features.</Typography>
        <DebugNewFeatureEntry overrideNewFeature={overrideFeatureSettings} />
      </div>
    );
  }

  return (
    <>
      <Typography fontWeight="bold" fontSize="small" mb={3}>
        Toggle Supported Features:
      </Typography>
      <Ul name="debug-feature-controls" skin="minimal" mb={5}>
        {activeFeatures.map((activeFeature, index) => (
          <DebugFeatureControls
            featureName={activeFeature.featureName}
            enabled={activeFeature.enabled}
            toggleFeature={overrideFeatureSettings}
            key={index}
          />
        ))}
      </Ul>
      <DebugNewFeatureEntry overrideNewFeature={overrideFeatureSettings} />
    </>
  );
};
